export const formatMyCompany = (myCompany: string): string =>{
   return myCompany?.includes("#") ? (
        myCompany.split("#")[1]
      ) : (
        myCompany
      )
}